import i18n from '@/js/i18n';
import profile from '@/services/api/compte/profile';
import { getQueryParamsValue } from '@/helpers/AppHelpers';
import { capitalize } from '@/helpers/StringHelpers';

// Profile Complet doit être en dehors de profile afin qu'il ne soit pas persisté dans la sessionStorage

const getDefaultState = () => {
  return {
    address: null,
    emailAddress: null,
    occupation: null,
    phoneNumber: null,
    profileUpdateStatus: 'unconfirmed',
  };
};

const state = getDefaultState();

const getters = {
  getIsDoublonProfession: (state) => {
    return (
      state.occupation &&
      state.occupation.text == state.occupation.industry.text &&
      state.occupation.industry.text == state.occupation.industry.occupation.text
    );
  },
};

const actions = {
  reset({ commit }) {
    commit('RESET');
  },

  async getProfileComplet({ state, commit }) {
    return new Promise((resolve, reject) => {
      profile
        .getInfoCompteCanafe()
        .then((response) => {
          commit('SET_INFO_PROFILE_COMPLET', response);
          commit('SET_PROFILE_COMPLET_PHONE_NUMBER', formatteTelephone(response.telephone));
          commit('SET_PROFILE_COMPLET_ADDRESS', response.address);
          resolve(state);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateProfileUpdateStatusSeen({ commit }) {
    if (getQueryParamsValue('info-pers') !== '1') {
      profile
        .setProfileUpdateStatusSeen()
        .then(() => {
          commit('SET_PROFILE_UPDATE_STATUS', 'seen');
        })
        .catch((error) => {
          throw error;
        });
    }
  },
};

const mutations = {
  RESET(state) {
    // Merge rather than replace so we don't lose observers
    // https://github.com/vuejs/vuex/issues/1118
    Object.assign(state, getDefaultState());
  },
  SET_INFO_PROFILE_COMPLET(state, profileComplet) {
    state.address = profileComplet.address;
    state.emailAddress = profileComplet.email;
    state.occupation = profileComplet.occupation;
    state.phoneNumber = profileComplet.telephone;
  },
  SET_PROFILE_COMPLET_PHONE_NUMBER(state, phoneNumber) {
    state.phoneNumber = formatteTelephone(phoneNumber);
  },
  SET_PROFILE_COMPLET_ADDRESS(state, address) {
    Object.assign(address, formatteAdresse(address));
    state.address = address;
  },
  SET_PROFILE_UPDATE_STATUS(state, status) {
    state.profileUpdateStatus = status;
  },
};

const formatteAdresse = (address) => {
  return {
    postcode: address.postcode.toUpperCase().replace(/\W/g, '').replace(/(...)/, '$1 '),
    addressLine2: capitalize(address.addressLine2.trim()),
    addressLine3: address.addressLine3
      ? (i18n.locale === 'en' ? 'Apt. ' : 'App. ') + address.addressLine3
      : '',
    city: capitalize(address.city.trim()),
    province: address.state || 'QC',
  };
};

const formatteTelephone = (phoneNumber) => {
  const number = phoneNumber.replace(/[^\d]/g, '');
  const arrayFormatTel = number.match(/(\d{3})(\d{3})(\d{4})/);

  if (arrayFormatTel) {
    return `${arrayFormatTel[1]} ${arrayFormatTel[2]}-${arrayFormatTel[3]}`;
  }

  return '';
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
